import React, { useEffect, useState } from 'react';
import DatePicker from '../DatePicker';
import { format, startOfToday } from 'date-fns';
import { useParams } from 'react-router-dom';
import { getVenueSchedule, getVenueDetail, bookVenueByAdmin } from '../../../api/VenueInteractor';
import { getTransactionDetail } from "../../../api/DashboardInteractor";
import { formatDate, numberFormatWithoutSymbol, showToast } from '../../../Utils';
import { Switch } from '@headlessui/react';
import classNames from 'classnames';
import BookingConfirmationDialog from './BookingConfirmationDialog';
import { apiCall } from '../../../api/Interactor';
import ConfirmationDialog from '../dialog/ConfirmationDialog';

function VenueSchedule(props) {

  const venueId = useParams()
  let [scheduleList, setScheduleList] = useState([])
  let [selectedSchedule, setSelectedSchedule] = useState([])
  let [selectedDate, setSelectedDate] = useState(startOfToday());
  let [specialPrice, setSpecialPrice] = useState(false)
  let [venue, setVenue] = useState(null)
  let [venueDetail, setVenueDetail] = useState(
    {
      "dateAvailable": "",
      "totalAll": "",
      "untilDate": "",
      "totalUnpaid": 0,
      "totalDpPaid": 0,
      "totalCancel": 0,
      "totalPaid": 0,
      "serviceFee": 0
    }
  )
  let [transactionId, setTransactionId] = useState(null)
  let [transactionDetail, setTransactionDetail] = useState(null)

  let [specialPriceAmount, setSpecialPriceAmount] = useState(0)
  let [isOpen, setIsOpen] = useState(false)
  let [isOpenRescheduleDialog, setIsOpenRescheduleDialog] = useState(false)
  let [isOpenCancelDialog, setIsOpenCancelDialog] = useState(false)
  const [scheduleClosedList, setScheduleClosedList] = useState([])

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  const showBookingDialog = () => {
    setSelectedSchedule(scheduleList.filter((item) => item.checked === true))
    openModal()
  }

  const getVenueDetailApi = () => {
    getVenueDetail(
      venueId.venueId,
      (responseJSON) => {
        console.log("result venue detail ", responseJSON.service_closes)
        setVenueDetail({ ...venueDetail, serviceFee: responseJSON.service_fee });
        setVenue(responseJSON)
        setScheduleClosedList(responseJSON.service_closes)
      },
      () => {

      }
    )
  }

  const getTransactionDetailApi = (transaction_id) => {
    getTransactionDetail(
      transaction_id,
      (responseJSON) => {
        console.log("result trx detail ", responseJSON);
        setTransactionDetail({ ...responseJSON, transaction_id: transaction_id });
        getScheduleApi(format(selectedDate, 'yyyy-MM-dd'))
      },
      //failed
      (message) => {
        showToast("Error", "Get Detail Failed", message);
      }
    );
  }

  useEffect(() => {
    onDaySelected(new Date());
    getVenueDetailApi();
  }, [venueId]);

  const onDaySelected = (selectedDate) => {
    const selectedDateString = format(selectedDate, 'yyyy-MM-dd')
    setSelectedDate(selectedDate)
    getScheduleApi(selectedDateString)
  }

  const getScheduleApi = (selectedDateString) => {
    getVenueSchedule(venueId.venueId, selectedDateString,
      (responseJSON) => {
        // console.log("ddd ", responseJSON)
        setVenueDetail({
          ...venueDetail, 
          "dateAvailable": responseJSON.date_available,
          "totalAll": responseJSON.total_all,
          "untilDate": responseJSON.until_date,
          "totalUnpaid": responseJSON.total_unpaid,
          "totalCancel": responseJSON.total_cancel,
          "totalDpPaid": responseJSON.total_dp_paid,
          "totalPaid": responseJSON.total_paid
        });
        let temp = []
        responseJSON.times.forEach(item => {
          item.checked = false
          temp.push(item)
        });
        setScheduleList(updateAvailability(temp))
      },
      (message) => {
        showToast("Error", "Get Schedule Failed", message)
      }
    )
  }

  function updateAvailability(times) {
    var tmpTimes = [...times];
    const currentDate = new Date();
    // if (format(selectedDate, 'yyyy-MM-dd') === format(currentDate, 'yyyy-MM-dd')) {
    // const currentHour = currentDate.getHours();
    // tmpTimes.forEach((item, index) => {
    //   const slotHour = parseInt(item.hour.split(":")[0]);
    //   // console.log("available", slotHour >= currentHour);
    //   if (slotHour <= currentHour) {
    //     tmpTimes[index].available = false;
    //   }
    // });
    // }
    return times;
  }

  const onBookingSucceed = () => {

    closeModal()
    getScheduleApi(format(selectedDate, 'yyyy-MM-dd'))
  }

  const validateBooking = () => {
    if (scheduleList.filter(item => item.checked).length !== transactionDetail.booking_times.length) {
      return {
        isValid: false,
        validationMessage: "Jadwal booking belum lengkap"
      }
    }

    return {
      isValid: true,
      validationMessage: ""
    }
  }


  const prepareBooking = () => {

    const validateResult = validateBooking()

    if (validateResult.isValid) {

      let selected_date = selectedDate;
      let subtotal = 0;
      let totalSchedule = 0;
      let totalAddon = 0;
      let discount = 0;
      let service_fee = venueDetail.serviceFee;
      let total = 0;

      let schedule = []
      scheduleList.forEach(item => {
        if (item.checked === true) {
          let promo_period = new Date(item.promo_period);
          totalSchedule += item.price;
          if (selected_date <= promo_period) {
            discount += item.price - item.promo_price;
          }
          schedule.push(
            {
              service_id: venueId.venueId,
              service_time_id: item.service_time_id,
              service_date: format(selectedDate, 'yyyy-MM-dd'),
              start_time: item.hour.split(" - ")[0],
              end_time: item.hour.split(" - ")[1],
              price: item.price,
            }
          );
        }
      });

      let selectedAddons = []
      transactionDetail.add_on_items.forEach(addon => {
        if (addon.qty > 0) {
          totalAddon += (addon.price * addon.qty);
          selectedAddons.push({
            add_on_item_id: addon.add_on_item_id,
            price: addon.price,
            qty: addon.qty,
            total: (addon.price * addon.qty)
          });
        }
      });

      subtotal = totalSchedule + totalAddon;
      total = subtotal - discount + service_fee;

      const param = {
        "service_member_book": {
          "service_id": venueId.venueId,
          "member_id": 0,
          "service_date": format(selectedDate, 'yyyy-MM-dd'),
          "contact_name": transactionDetail.name,
          "contact_phone": transactionDetail.phone,
          "contact_email": transactionDetail.email,
          "total_payment": total,
          "total_dp": 0,
          "booking_times_attributes": schedule,
          "add_on_item_service_member_books_attributes": selectedAddons,
          "transaction_services_attributes":
            [
              {
                "community_id": 0,
                "payment_with": "",
                "pg_code": 0,
                "pg_name": "PAYMENT ADMIN",
                "package_unit": "",
                "qty": 1,
                "package_price": 0,
                "discount": discount,
                "service_fee": service_fee,
                "admin_fee": 0,
                "total": total + discount - service_fee,
                "is_dp": 0
              }
            ]
        }
      }

      console.log("eee ", param)




      bookVenueByAdmin(param,
        //success
        (responseJSON) => {
          cancelBooking(transactionDetail.transaction_id)
          setTransactionDetail(null)
        },
        //failed
        (message) => {
          cancelBooking(transactionDetail.transaction_id)
          setTransactionDetail(null)
        }
      )

    } else {
      showToast("Error", "Failed", validateResult.validationMessage)
    }
  }

  const cancelBooking = (transaction_id) => {
    apiCall(
      "POST", process.env.REACT_APP_VENUE_BOOKING_CANCEL,
      {
        transaction_id: transaction_id
      },
      (response) => {
        getScheduleApi(format(selectedDate, 'yyyy-MM-dd'))
      },
      (message) => {
        getScheduleApi(format(selectedDate, 'yyyy-MM-dd'))
      }
    )
  }

  const renderSchedule = () => {
    return (
      <div className='flex flex-col gap-[20px] overflow-scroll h-[600px]'>
        {
          scheduleList.map((item, index) => {

            if (item.available) {
              return (
                <div
                  // onClick={(e) => onScheduleClick(item.hour)}
                  onClick={(e) => {
                    // scheduleList[index].checked = !scheduleList[index].checked
                    // setScheduleList(scheduleList)
                  }}
                  className={classNames(
                    // isScheduleExist(item.hour, selectedSchedule) >= 0
                    //   ? 'bg-primaryRed text-white'
                    //   : 'hover:bg-blue-100',
                    'cursor-pointer flex justify-between items-center py-[14px] px-4 rounded-xl border border-primaryRed text-sm text-primaryRed font-[600]'
                  )}
                >
                  <div>
                    <span>{item.hour}</span>
                    {
                      new Date(item.promo_period) >= selectedDate ? (
                        <>
                          <p className='text-sm line-through'>Rp. {numberFormatWithoutSymbol(item.price)}</p>
                          <p className='text-sm'>Rp. {numberFormatWithoutSymbol(item.promo_price)}</p>
                        </>
                      ) : (
                        <>
                          <p className='text-sm'>Rp. {numberFormatWithoutSymbol(item.price)}</p>
                        </>
                      )
                    }
                  </div>
                  <input
                    id={`checkbox-table-${index}`}
                    type="checkbox"
                    hidden={transactionDetail !== null && scheduleList.filter(item => item.checked).length === transactionDetail.booking_times.length && item.checked === false}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    checked={item.checked}
                    onChange={(e) => {
                      const newCheckedValue = e.target.checked;

                      // Create a new scheduleList with the updated item
                      const updatedScheduleList = scheduleList.map((scheduleItem, i) =>
                        i === index ? { ...scheduleItem, checked: newCheckedValue } : scheduleItem
                      );

                      // Set the new scheduleList state
                      setScheduleList(updatedScheduleList);

                      console.log(newCheckedValue); // Log the updated checkbox state
                      console.log(updatedScheduleList); // Log the updated schedule list
                    }}
                  />

                </div>

              )
            } else {
              return (
                <div className='relative flex flex-col rounded-lg border border-[#d1d1d1] bg-[#efefef] text-sm px-[18px] py-[18px]'>

                  {/* Status Badge (Top Right) */}
                  <div className={`${item.status === "paid" ? "bg-[#87c816]" : "bg-primaryRed"} absolute top-2 right-2 h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]`}>
                    {item.status === "paid" ? "LUNAS" : "BELUM LUNAS"}
                  </div>

                  {/* Main Content */}
                  <div className='flex flex-col h-[40px]' >
                    <div className='flex flex-row'>
                      <p className='mb-[14px] font-bold text-gray-800'>
                        {item.hour}
                      </p>
                    </div>
                    <p className='font-[500] text-gray-800'>
                      {item.contact_name}
                    </p>
                  </div>

                  {/* Action Buttons (Bottom Right) */}
                  <div className='absolute bottom-2 right-2 flex'>
                    <div
                      className='flex h-fit border border-primaryRed items-center rounded-lg px-4 py-1.5 text-black font-semibold text-[10px] cursor-pointer'
                      onClick={() => getTransactionDetailApi(item.transaction_id)}
                    >
                      RESCHEDULE
                    </div>
                    <div
                      className='flex h-fit ml-2 border border-primaryRed items-center rounded-lg px-4 py-1.5 text-black font-semibold text-[10px] cursor-pointer'
                      onClick={() => {
                        setTransactionId(item.transaction_id)
                        setIsOpenCancelDialog(true)
                      }}
                    >
                      BATALKAN TRANSAKSI
                    </div>
                  </div>
                </div>


              )
            }

          })
        }




      </div >
    )
  }

  return venue==null?(<></>):(
    <div className='h-full flex flex-col flex-1 justify-between'>

      <div className='flex flex-col overflow-hidden px-4 py-4'>
        <p className='text-2xl my-4 text-left text-gray-800 font-bold'>{venue?.name}</p>

        {
          transactionDetail !== null && (<>
            <div className='flex justify-center items-center rounded-lg border border-[#d1d1d1] bg-[#efefef] text-sm pr-[12px] pl-[18px] py-[12px]'>
              <div className='flex flex-col flex-grow  '>
                <div className='flex items-center justify-between'>
                  <div className='text-lg text-left text-gray-800 font-semibold'>Reschedule Jadwal</div>
                  <img src='/ic-close-solid.svg' alt="Close" className='ml-auto' onClick={() => {
                    setTransactionDetail(null)
                    getScheduleApi(format(selectedDate, 'yyyy-MM-dd'))
                  }} />
                </div>

                <div>
                  <table>
                    <tr>
                      <td>Nama</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{transactionDetail.name}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{transactionDetail.email}</td>
                    </tr>
                    <tr>
                      <td>No. Tlp</td>
                      <td>&nbsp;:&nbsp;</td>
                      <td>{transactionDetail.phone}</td>
                    </tr>
                  </table>
                </div>

                <div className="flex flex-row mt-2">
                  <div className="w-1/2">
                    <p className="font-semibold text-gray-800">
                      Jadwal Lama
                    </p>
                    <table>
                      <tr>
                        <td>Tanggal</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{transactionDetail.booking_times.length > 0 ? transactionDetail.booking_times[0].booking_date : ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: 'top' }}>Jam</td>
                        <td style={{ verticalAlign: 'top' }}>&nbsp;:&nbsp;</td>
                        <td>
                          {
                            transactionDetail.booking_times.map((item, index) => (
                              <span key={index}>
                                {item.booking_time}
                                <br />
                              </span>
                            ))
                          }
                        </td>
                      </tr>

                    </table>
                  </div>

                  <div className="w-1/2">
                    <p className="font-semibold text-gray-800">
                      Jadwal Baru
                    </p>
                    <table>
                      <tr>
                        <td>Tanggal</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{format(selectedDate, 'yyyy-MM-dd') ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: 'top' }}>Jam</td>
                        <td style={{ verticalAlign: 'top' }}>&nbsp;:&nbsp;</td>
                        <td>
                          {
                            scheduleList.map((item, index) => (
                              item.checked && <span key={index}>
                                {item.hour}
                                <br />
                              </span>

                            ))
                          }
                        </td>
                      </tr>

                    </table>
                  </div>
                </div>




              </div>
            </div>
          </>)
        }


        <div className='flex gap-x-4  py-4'>

          {/* left pane */}
          <div className='flex flex-col gap-y-4 w-1/2'>
            <div className='flex justify-between  items-center'>
              <p className='text-sm font-[500]'>Pilih Hari</p>
              <p className='text-md font-[600]'>{formatDate(venueDetail.dateAvailable)}</p>
            </div>
            <DatePicker
              className='flex w-1/2' onDaySelected={onDaySelected} scheduleClosedList={scheduleClosedList} />


            {/* total transaksi */}
            <div className='flex flex-col gap-6 rounded-lg px-4 py-6'>

              <div className='flex  justify-between'>
                <div>
                  <p className='text-[11px] font-semibold text-gray-800'>Total Transaksi</p>
                  <p className='mt-3 font-bold text-gray-800'>
                    <span className='text-sm'>Rp</span>
                    <span className='text-2xl ml-0.5'>{numberFormatWithoutSymbol(venueDetail.totalAll)}</span>
                  </p>
                </div>

                <div className='flex flex-col items-end'>
                  <p className='text-[11px] font-base text-gray-800'>Sampai Tanggal</p>
                  <p className='mt-2 font-bold text-gray-800'>
                    <span className='text-[14px] ml-0.5'>{formatDate(venueDetail.untilDate)}</span>
                  </p>
                </div>

              </div>


              <div className=' grid grid-cols-2 gap-4'>

                <div className='flex gap-2 items-center '>
                  <div className='bg-[#87c816] flex h-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]'>
                    LUNAS
                  </div>
                  <p className=' font-semibold text-gray-800'>
                    <span className='text-xs'>Rp</span>
                    <span className='text-md ml-0.5'>{numberFormatWithoutSymbol(venueDetail.totalPaid)}</span>
                  </p>
                </div>


                {/* <div className='flex gap-2 items-center '>
                  <div className='bg-[#ffaa00] flex h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                    DP Paid
                  </div>
                  <p className=' font-semibold text-gray-800'>
                    <span className='text-xs'>Rp</span>
                    <span className='text-md ml-0.5'>{venueDetail.totalDpPaid}</span>
                  </p>
                </div> */}

                <div className='flex gap-2 items-center '>
                  <div className='bg-[#ca4e4e] flex h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]'>
                    UNPAID
                  </div>
                  <p className=' font-semibold text-gray-800'>
                    <span className='text-xs'>Rp</span>
                    <span className='text-md ml-0.5'>{numberFormatWithoutSymbol(venueDetail.totalUnpaid)}</span>
                  </p>
                </div>

                <div className='flex gap-2 items-center '>
                  <div className='bg-[#ca4e4e] flex h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]'>
                    CANCEL
                  </div>
                  <p className=' font-semibold text-gray-800'>
                    <span className='text-xs'>Rp</span>
                    <span className='text-md ml-0.5'>{numberFormatWithoutSymbol(venueDetail.totalCancel)}</span>
                  </p>
                </div>

                {/* <div className='flex gap-2 items-center '>
                <div className='bg-[#ca4e4e] flex h-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                  CANCEL
                </div>
                <p className=' font-semibold text-gray-800'>
                  <span className='text-xs'>Rp</span>
                  <span className='text-md ml-0.5'>14.000.000</span>
                </p>
              </div> */}

              </div>

            </div>

          </div>


          {/* right pane */}
          <div className='flex flex-col gap-y-4 w-1/2'>
            <div className='flex justify-between   items-center'>
              <p className='text-sm font-[500]'>Pilih Jam</p>
              <p className='text-md font-[600]'>&nbsp;</p>
            </div>

            {renderSchedule()}
            <button
              onClick={() => {
                if (transactionDetail == null) {
                  showBookingDialog()
                } else {
                  setIsOpenRescheduleDialog(true)
                }
              }}
              className={`cursor-pointer flex w-fit h-10 mr-6 items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-md ml-auto`}>
              {/* <img src='/ic_send.png' className='w-4 mr-2' />  */}
              {transactionDetail == null ? "Buat Pesanan" : "Reschedule Jadwal"}

            </button>
          </div>


        </div>


        {/* bottom nav */}
        {/* <div className={classNames(selectedSchedule.length > 0 ? '' : ' translate-y-full ', ' transition-transform duration-900 fixed bottom-0 left-0 right-0 bg-white py-6 items-center')}>
          <div className="flex gap-x-8 max-w-6xl w-full pl-18  items-center mx-auto">
            <p className='text-lg mx-4 text-left text-gray-900 font-bold'>Booking <br /> Jadwal</p>

            <div className='flex flex-col gap-y-2 flex-grow'>
              <p className='text-md font-[500] tracking-wider'>{formatDate(venueDetail.dateAvailable)}</p>
              <div className='grid grid-cols-2 gap-x-6 gap-y-2 '>

                {selectedSchedule.map((item) => {
                  return (
                    <p className='text-md font-[700] tracking-widest'>{item.start_time + " - " + item.end_time}</p>

                  )
                })}

              </div>
            </div>

            <div className='flex gap-x-4 items-center'>

              <Switch
                checked={specialPrice}
                onChange={setSpecialPrice}
                className={`${specialPrice ? 'bg-[#fff6d9]' : 'bg-[#fff6d9]'}
                              relative inline-flex h-[24px] w-[48px] shrink-0 cursor-pointer rounded-lg border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
              >
                <span className="sr-only">Use setting</span>
                <span
                  aria-hidden="true"
                  className={`${specialPrice ? 'translate-x-6 bg-[#ffc91a] ' : ' translate-x-0 bg-amber-200 '}
                              pointer-events-none inline-block h-[20px] w-[20px] transform rounded-lg  shadow-lg ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>


              <p className='text-sm font-[500] '>Harga Khusus</p>
              <input onChange={(e) => { setSpecialPriceAmount(e.target.value) }} value={specialPriceAmount} disabled={!specialPrice} type='text' className='disabled:bg-gray-100 transition-opacity duration-900 disabled:opacity-75   bg-gray-200 px-6 py-3 text-sm font-bold rounded-lg' placeholder='Input Harga' />
            </div>
            
          </div>
        </div> */}

      </div>

      <BookingConfirmationDialog onBookingSucceed={onBookingSucceed} closeModal={closeModal} open={isOpen} venueId={venueId} selectedSchedule={selectedSchedule} specialPrice={specialPrice} specialPriceAmount={specialPriceAmount} venueDetail={venueDetail} />

      <ConfirmationDialog
        title={"Konfirmasi"}
        message={"Apakah yakin untuk reschedule?"}
        isOpen={isOpenRescheduleDialog}
        onClose={() => {
          setIsOpenRescheduleDialog(false)
        }}
        onConfirm={() => {
          setIsOpenRescheduleDialog(false)
          prepareBooking()
        }}
      />
      <ConfirmationDialog
        title={"Konfirmasi"}
        message={"Apakah yakin untuk mebatalkan transaksi ini?"}
        isOpen={isOpenCancelDialog}
        onClose={() => {
          setIsOpenCancelDialog(false)
        }}
        onConfirm={() => {
          setIsOpenCancelDialog(false)
          cancelBooking(transactionId)
        }}
      />

    </div>

  );
}

export default VenueSchedule;